import React, { useEffect, useMemo, useState } from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import { allTasks, stages, view } from "../_mocks/staticData";
import { shallowEqual, useSelector, useDispatch } from "react-redux";

import { Formik } from "formik";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { dealsFranchiseListing } from "../../ContactDeals/_redux/deals/dealsCrud";
import { isEqual } from "lodash";
import { useIntl } from "react-intl";
import { useQTasksUIContext } from "../KycUIContext";
import { CustomeSearch } from "../../../../_metronic/_partials/controls/CustomeSearch";
import { fetchAgent } from "../../ContactDeals/_redux/contact/contactAction";

/**
 * Build the list query from the filter form values.
 *
 * @param {Object} queryParams Current paging/sorting/filter query
 * @param {Object} values Filter form values (status, searchText, ...)
 * @returns {Object} The new query params, with `filter` replaced
 */
const prepareFilter = (queryParams, values) => {
  const {
    searchText,
    search_type,
    search_view,
    search_owner,
    search_franchise,
    search_stage,
    priority,
    status
  } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  filter.search = searchText ? searchText : "";
  filter.search_view = search_view ? search_view : "";
  filter.search_owner = search_owner ? search_owner : "";
  filter.search_franchise = search_franchise ? search_franchise : "";
  filter.priority = priority ? priority : "";
  filter.search_type = search_type ? search_type : "";
  filter.search_stage = search_stage ? search_stage : "";
  filter.status = status ? status : ""

  newQueryParams.filter = filter;
  return newQueryParams;
};
/**
 * Filter bar for the Onboarding (KYC) list: status dropdown and search.
 *
 * @param {Object} props
 * @param {*} [props.check] Unused; kept for existing callers
 * @returns {JSX.Element}
 */
export function KycFilter({ check }) {
  const intl = useIntl();
  const tasksUIContext = useQTasksUIContext();

  const [franchises, setFranchise] = useState([]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state.contact.agent }),
    shallowEqual
  );
  const dispatch = useDispatch();
  const tasksUIProps = useMemo(() => {
    return {
      setQueryParams: tasksUIContext.setQueryParams,
      queryParams: tasksUIContext.queryParams,
    };
  }, [tasksUIContext]);

  /**
   * Apply the filter form values to the list, returning to page 1 when
   * they change.
   *
   * @param {Object} values Filter form values
   */
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(tasksUIProps.queryParams, values);

    if (!isEqual(newQueryParams, tasksUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      tasksUIProps.setQueryParams(newQueryParams);
    }
  };

  const handleFranchiseList = () => {
    dealsFranchiseListing().then((res) => {
      setFranchise(res.data.data);
    });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      handleFranchiseList();
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);
  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(fetchAgent());
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [dispatch]);
  return (
    <>
      <Formik
        initialValues={{
          search_type: "", // values => All=""/Susspended=0/Active=1/Pending=2
          search_view: "",
          search_owner: "",
          search_franchise: "", // values => All=""/Business=0/Individual=1
          searchText: "",
          search_stage: "",
          priority: "",
          status: ""
        }}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,

          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row d-flex justify-content-between">
              {/* <div className="col-lg-10">
                <h5 class="text-dark font-weight-bold my-2 mr-5">Quotes</h5>
              </div> */}
              <div className="col-lg-3 order-flt">
                <span className="mt-3">
                  Status:&nbsp;{" "}
                </span>
                <FormControl fullWidth>
                  <Select
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                    className="form-control"
                    onChange={(e) => {
                      // Apply the value just picked: Formik's state update is not
                      // visible to a submit in the same handler, so handleSubmit()
                      // here filtered by the previous choice.
                      const status = e.target.value;
                      setFieldValue("status", status);
                      applyFilter({ ...values, status });
                    }}
                    name="Kyc status"
                    onBlur={handleBlur}
                    value={values.status}
                    displayEmpty
                    IconComponent={(props) => (
                      <i {...props}>
                        <KeyboardArrowDownIcon />
                      </i>
                    )}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="">
                      Select
                    </MenuItem>
                    <MenuItem value="pending_kyc">
                      ID Verification Pending
                    </MenuItem>
                      <MenuItem value="pending_manual_kyc">
                      Manual ID Verification Pending
                    </MenuItem>
                      <MenuItem value="pending_contract_sign">
                      eContract Sign Pending
                    </MenuItem>
                    <MenuItem value="pending_manual_contract_sign">
                      Manual eContract Sign Pending
                    </MenuItem>
                    <MenuItem value="void_1_hour_before_kyc">
                      Cancelled before ID Verification
                    </MenuItem>
                    <MenuItem value="void_1_hour_before_sign">
                      Cancelled before eContract
                    </MenuItem>
                      <MenuItem value="pending_access">
                      Pending Lockvue Access
                    </MenuItem>
                     <MenuItem value="complete">
                      Onboarding Complete
                    </MenuItem>
                    <MenuItem value="name_check_pending">
                      ID Name Check Needed
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="col-lg-2 order-flt mt-2">
                <CustomeSearch
                  intl={intl}
                  handleBlur={handleBlur}
                  values={values}
                  setFieldValue={setFieldValue}
                  handleSubmit={handleSubmit}
                  topData={"22px"}
                />
                {/* <div style={{ position: "relative" }}>
                  <input
                    style={{ paddingRight: "40px" }}
                    type="text"
                    className="form-control"
                    name="searchText"
                    placeholder={intl.formatMessage({ id: "Search" })}
                    onBlur={handleBlur}
                    value={values.searchText}
                    onChange={(e) => {
                      setFieldValue("searchText", e.target.value);
                      handleSubmit();
                    }}
                  />
                  <i
                    style={{
                      position: "absolute",
                      top: "22px",
                      transform: "translateY(-50%)",
                      right: "15px",
                    }}
                    className="fa fa-search taskSearch"
                    aria-hidden="true"
                  ></i>
                </div> */}
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
